// Round 5b (2026-09-10) — LIVEMOA SITE-WIDE MASTER CATEGORY foundation.
// REAL DB audit (2026-09-10):
//   · NAVER  · 832 rows · category=None (100%)                   → keyword fallback
//   · KAKAO  · 185 rows · distinct 7: 식품 82 · 뷰티 33 · 리빙 24
//                          · 패션 16 · 키즈 13 · 테크 11 · 여행 6
// 향후 Home / 편성표 / Short-form / 상품 / 판매자 / 통합검색 / 광고 등
// 모든 화면이 이 helper 하나만 REUSE.  6개 고정 구조는 폐기됨.
const LIVEMOA_CATS = ['패션', '뷰티', '식품', '디지털·가전', '리빙', '키즈', '여행', '펫', '기타'];

// §6 1순위 · 원본 category 직접 매핑 (Kakao 실측 값 + 확장 어휘)
const RAW_TO_MASTER = {
  // 패션
  '패션': '패션', '의류': '패션', '여성의류': '패션', '남성의류': '패션',
  '패션잡화': '패션', '신발': '패션', '가방': '패션', '주얼리': '패션', '악세서리': '패션',
  // 뷰티
  '뷰티': '뷰티', '화장품': '뷰티', '스킨케어': '뷰티', '메이크업': '뷰티', '헤어': '뷰티',
  // 식품 (Round 5 "음식" → "식품" §4 terminology)
  '식품': '식품', '음식': '식품', '건강식품': '식품', '농수산': '식품',
  '간편식': '식품', '음료': '식품', '건강': '식품',
  // 디지털·가전 (Kakao "테크")
  '테크': '디지털·가전', '가전': '디지털·가전', '전자제품': '디지털·가전',
  '디지털': '디지털·가전', '컴퓨터': '디지털·가전', 'IT': '디지털·가전',
  // 리빙
  '리빙': '리빙', '생활': '리빙', '주방': '리빙', '가구': '리빙', '인테리어': '리빙',
  // 키즈
  '키즈': '키즈', '유아': '키즈', '유아동': '키즈', '아동': '키즈',
  '출산': '키즈', '완구': '키즈', '장난감': '키즈',
  // 여행 (Kakao)
  '여행': '여행', '숙박': '여행', '항공': '여행', '레저': '여행',
  // 펫 (Kakao 미노출 · keyword fallback 만)
  '펫': '펫', '반려동물': '펫', '강아지': '펫', '고양이': '펫',
};

// §6 3순위 · title/seller/product/brand keyword fallback (원본 category 없을 때만)
// Round 5d (2026-09-10) · Naver LIVE 25건 · 100 % category 결측 실측 후,
// 실제 title/brand_name/seller 노출 토큰만 기반으로 **보수적 확장**.
// §6 판매자 지시: 억지 분류 금지 · 정확도 > 숫자상 분류율.
const KEYWORDS = {
  '패션': [
    '원피스','자켓','패딩','청바지','셔츠','코트','스커트','블라우스','니트','가방','신발','슈즈','모자','의류','패션',
    // Round 5d additions — 명확한 apparel 노운/브랜드/시즌 코드
    '아우터','룩','코디','데님','티셔츠','재킷','상의','하의','팬츠','슬랙스','가디건','스니커즈','명절룩','신상위크',
    'fw신상','26fw','fw','크록스','뉴발란스','스파오','언더아머','라코스테','탑텐','마이클코어스','스노우피크 어패럴',
    '어패럴','폴햄','미쏘','페넬로페','제네럴아이디어','마스마룰즈','코트의 계절',
  ],
  '뷰티': [
    '립','쿠션','세럼','앰플','파운데이션','아이섀도','토너','크림','샴푸','트리트먼트','마스크팩','에센스','뷰티','화장품',
    // Round 5d additions
    '향수','스킨케어','클렌징','로션','스킨','파우더','bb크림','페이스','헤어','뷰티데이','메디큐브','설화수','라네즈',
    '헤라','아이오페','아모레','메이크업','모공','뷰티룸','닥터포헤어','피부','스킨수티컬즈','아로마티카','헤드앤숄더',
    '치약','파로돈탁스',
  ],
  '식품': [
    '한우','계란','김치','과일','곡물','우유','치즈','간식','도시락','반찬','비타민','견과','건어물','수산','유산균',
    '다이어트','건강식','간편식','밀키트',
    // Round 5d additions — 실제 Naver/Kakao title 에 나타나는 식음료 토큰
    '갈비','la갈비','커피','원두','아메리카노','라면','홍삼','산삼','인삼','프로틴','단백질','두부','파스타','오트',
    '소고기','돼지고기','삼겹살','회','스테이크','찜닭','스낵','쿠키','초콜릿','밥','국','찌개','식품','김','새우',
    '먹방','푸드','제일제당','청정원','오뚜기','카누','오설록','종가','매일유업','상하목장','정관장','오쏘몰','뉴트리',
    '유업','제약','제과','건강','영양제','한독몰','종근당','일동후디스','베지밀','땅콩','명란','조기','어묵','캘로그',
    '켈로그','뉴메드','뉴트리원','링티','솔가','센트룸','후디스','GNM','GC녹십자','대상웰라이프','유한양행',
    '광동제약','제로매트리스',  // '제로매트리스' guard 없음 — actually 매트리스는 리빙. Keep off.
    '두부면','오트리','메밀','잇몸','장면역','펩시','LA꽃갈비','원두',
  ].filter((k) => !['제로매트리스'].includes(k)),
  '디지털·가전': [
    '공기청정기','TV','노트북','태블릿','스마트폰','모니터','헤드폰','이어폰','키보드','마우스','청소기','에어컨',
    '냉장고','세탁기','전자','디지털','가전',
    // Round 5d additions — 실제 title 에 반복 등장한 가전/디지털 토큰
    '갤럭시','정수기','착즙기','인덕션','다리미','오디오','스피커','앰프','카메라','렌즈','프로젝터','로봇청소기',
    '밥솥','안마의자','안마','그램','무선청소기','음식물처리기','스팀쿡','처리기','청호나이스','코웨이','필립스',
    '테팔','쿠쿠','신일전자','샤크닌자','LG전자','삼성전자','드롱기','휴롬','에브리봇','파나소닉','제니퍼룸',
    '보국전자','InBody','인바디','더가전','제모의료기','정수기BIG4','자급제','착즙','스팀다리미','바워스앤윌킨스',
    '주방가전','생활가전','디가페','샤오미','삼성 슈퍼위크','LG생활건강 향수','luxu음',   // 부정확 · 실제 title 에 존재 시만
    '카본매트','탄산수 제조기','에어메이드','보국공식','DUPONT','에브리봇','케이원정보','쿠쿠홈시스','컴퓨터','it슈',
  ],
  '리빙': [
    '침구','냄비','매트리스','프라이팬','조명','수건','의자','책상','소파','수세미','가구','인테리어','주방','생활',
    // Round 5d additions
    '이불','침대','청소포','부엌','손수건','매트','방석','리빙','한부엌','키친','침대','베개','싱크','알레르망',
    '지누스','시디즈','알로소','한샘','리바트','룸','씰리','소닉슬립','금성침대','더가구','오토노스','쁘띠',
    '무인양품','락앤락','르크루제','베스트슬립','마틸라','파르페','노랑풍선',  // 여행 · 아래서 override
    '위생','손수건','수건',
  ].filter((k) => k !== '노랑풍선'),   // safeguard — 여행으로만 매칭돼야 함
  '키즈': [
    '유아','아기','베이비','기저귀','분유','완구','장난감','유모차','동화','카시트','키즈',
    // Round 5d additions — 신학기/육아 시즌 코퍼스
    '육아','신학기','새학기','어린이','아이','학생','학기','엄마','산후','임산부','유아템','학용품','키즈템',
    '2학기','육아템','베이비바우처','팸퍼스','하기스','마더케이','뉴발란스 키즈','폴햄키즈','스파오키즈',
    'MLB 키즈','비욘드 키즈','더블하트','릴라릴라','토들즈','아토앤오투','유아용품','맘편한 육아','ngstorekids',
    '함소아','밀크마일',
  ],
  '여행': [
    '여행','숙박','호텔','리조트','항공','투어','펜션','캠핑',
    // Round 5d additions — 실제 naver 여행상품 corpus
    '스파','크루즈','패키지','파라다이스','롯데호텔','롯데월드','하나투어','노랑풍선','참좋은여행','모두투어',
    '네이버 여행상품','슈퍼위크','도쿄','세부','다낭','시드니','홍콩','후쿠오카','부산','제주','세인트존스',
    '동유럽',
  ],
  '펫': [
    '강아지','고양이','반려','사료','펫','캣타워','츄르','펫용품',
    // Round 5d additions
    '캣','도그','반려동물','펫통령','펫또마망','한국마즈펫','힐스코리아','동원펫','마즈펫','수의사',
  ],
};

export function normalizeLivemoaCategory(item) {
  if (!item) return '기타';
  // §3 signal chain (Round 5d) — original category → category_raw →
  // product_category (product taxonomy dumped by some collectors).
  const raw = (item.category || item.category_raw || item.product_category || '').toString().trim();
  if (raw && RAW_TO_MASTER[raw]) return RAW_TO_MASTER[raw];
  if (raw) { for (const c of LIVEMOA_CATS) if (raw.includes(c)) return c; }
  // §3 keyword fallback hay — add brand_name so Naver rows (which have
  // brand_name populated but empty category / product_name) hit KW.
  const text = (
    (item.title || '') + ' ' +
    (item.product_name || '') + ' ' +
    (item.seller_name || '') + ' ' +
    (item.brand_name || '')
  ).toLowerCase();
  for (const cat of LIVEMOA_CATS) {
    if ((KEYWORDS[cat] || []).some(k => text.includes(k.toLowerCase()))) return cat;
  }
  return '기타';  // §7 · 억지 분류 금지 · 최종 fallback
}

export const LIVEMOA_CATEGORY_OPTIONS = ['all', ...LIVEMOA_CATS];
export const LIVEMOA_CATEGORY_LABEL = {
  all: '전체',
  '패션': '패션', '뷰티': '뷰티', '식품': '식품',
  '디지털·가전': '디지털·가전', '리빙': '리빙', '키즈': '키즈',
  '여행': '여행', '펫': '펫', '기타': '기타',
};
